import { FigmaFileStructureNodeBase, FigmaFileStructureOrigin, FigmaFileStructureStatistics, } from "../elements";
import { ImportModelBase, ImportModelInputBase } from "./base";
import { z } from "zod";
//
// Nodes Import Model
//
export const FigmaFileStructureNodeImportModel = FigmaFileStructureNodeBase.extend({
    children: z.lazy(() => FigmaFileStructureNodeImportModel.array()),
});
//
// Structure Import Model
//
const FigmaFileStructureImportModelPart = z.object({
    data: z.object({
        rootNode: FigmaFileStructureNodeImportModel,
        assetsInFile: FigmaFileStructureStatistics,
    }),
});
export const FigmaFileStructureImportModel = ImportModelBase.extend(FigmaFileStructureImportModelPart.shape).extend({
    origin: FigmaFileStructureOrigin,
});
//
// Import model input
//
export const FigmaFileStructureImportModelInput = ImportModelInputBase.extend(FigmaFileStructureImportModelPart.shape).extend({
    fileVersionId: z.string(),
});
export function figmaFileStructureImportModelToMap(root) {
    const map = new Map();
    recursiveFigmaFileStructureToMap(root, map);
    return map;
}
function recursiveFigmaFileStructureToMap(node, map) {
    map.set(node.id, node);
    for (const child of node.children)
        recursiveFigmaFileStructureToMap(child, map);
}
